export default {
    lang: 'zh',
    frame: {
        'desc_title': '关于本站',
        tabbar: {
            'index': '首页',
            'about': '关于',
            'trends': '动态'
        },
        open: {
            'qqgroup': '粉丝群',
            'liveroom': '直播间',
            'biligroup': '应援团'
        }
    },
    app: {
        'title': '咕狸咕狸 - 画鸳咕咕子应援站!',
        'title_suffix': '\\(￣︶￣*\\))',
        'desc': [
            '本网站是画鸳咕咕子的应援站是怎么回事呢？本网站相信大家都很熟悉，但是本网站是画鸳咕咕子的应援站是怎么回事呢，下面就让小编带大家一起了解吧。',
            '本网站是画鸳咕咕子的应援站，其实就是因为画鸢咕咕子天下第一，大家可能会很惊讶本网站怎么会是画鸳咕咕子的应援站呢？但事实就是这样，小编也感到非常惊讶。',
            '这就是关于本网站是画鸳咕咕子的应援站的事情了，大家有什么想法呢，欢迎在评论区告诉小编一起讨论哦！',
        ]
    },
    info: {
        'live_room_id': '5480845',
        'qq_group_link': 'https://qm.qq.com/cgi-bin/qm/qr?k=to8q9ONHoAgD1gniDsQMIND70MuqjDmQ&authKey=mKhiJCEsDSFx0mI2svfcvDb2wIJ+uFCaXGwnfvSDmGpEhlDIashHYC9AXt1EnYvc',
        'houyuan_link': 'http://link.bilibili.com/h5/im/app?bilifrom=1&params=eyJpZCI6MjIxMDUzOTMyLCJ0eXBlIjoxfQ%3D%3D',
    },
};
